import template from './employee_attendance_report.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class EmployeeAttendanceViewModel
{
	constructor (page)
	{
		this.page = page;

		this.date_start_filter = ko.observable(moment().format('YYYY-MM-01'));
		this.employee_attendance = ko.observableArray();
		this.selected_department = ko.observable();
		this.current_department_id = ko.observableArray();
		this.leave_types = ko.observableArray();
		this.leave_type_id = ko.observable();
		this.loader = ko.observable(false);
		this.show_hint = ko.observable(true);
		this.show_no_data_message = ko.observable(false);

		this.selected_department.subscribe((newValue) => {
			this.employee_attendance([]);
			this.show_hint(true);
			this.show_no_data_message(false);

			if (newValue != null)
				this.current_department_id(newValue.department_id);
			else
				this.current_department_id(null);
		});
	}

	show_report_help()
	{
		Grape.dialog.open('EmployeeAttendanceInformationHelp', { employee_id: this.page.bindings.id });
	}

	async download_clicked(v, e)
	{
		// Check if there's any data to download
		if (this.employee_attendance().length === 0) {
			await Grape.alerts.alert({title: 'Warning', type: 'warning', message: 'No data to download'});
			return;
		}

		// Build CSV from the actual data array
		let csv_rows = [];

		// Add header row
		csv_rows.push(['Full names', 'Leave description'].map(h => `"${h}"`).join(','));

		// Add data rows from the observable array
		this.employee_attendance().forEach(record => {
			let fullname = `${record.firstname} ${record.surname}`;
			let description = record.description || '';

			// Properly escape quotes and wrap in quotes
			csv_rows.push([
				`"${fullname.replace(/"/g, '""')}"`,
				`"${description.replace(/"/g, '""')}"`
			].join(','));
		});

		let csv_string = csv_rows.join('\n');

		// Create and download the file
		let blob = new Blob([csv_string], { type: 'text/csv;charset=utf-8;' });
		let link = document.createElement('a');

		link.href = URL.createObjectURL(blob);
		link.setAttribute('download', 'employee_attendance_report.csv');

		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}
}

class EmployeeAttendancePage 
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new EmployeeAttendanceViewModel(this);
	}

	async init()
	{
		// check access to page
		if (await Utils.redirectOnAccessDenied('EmployeeAttendanceInfoReport'))
			return;

		document.title = tr('Employee Attendance Information');
		window.current_page_title(tr('Employee Attendance Information'));

		let res = await Grape.fetches.getJSON('/api/record', {
			table: 'leave_type',
			sortfield: 'description',
			sortorder: 'asc',
			limit: 1000000
		});

		if (res)
			this.viewModel.leave_types(res.records);
	}

	updateData()
	{
		if (this.viewModel.current_department_id() != '' && this.viewModel.date_start_filter() != '' && this.viewModel.date_start_filter() != undefined)
			this.update_report_data();
	}

	async update_report_data()
	{
		let data = {
			department_id: this.viewModel.current_department_id(),
			date_start_filter: this.viewModel.date_start_filter(),
			leave_type_id: this.viewModel.leave_type_id()
		};

		this.viewModel.loader(true);

		let res = await Grape.fetches.postJSON('/reports/employee_attendace_report', data);

		if (res)
		{
			this.viewModel.employee_attendance(res);
			this.viewModel.show_hint(false);
			this.viewModel.loader(false);
		}

		if (res.length == undefined)
			this.viewModel.show_no_data_message(true);
	}
}

export default {
	route: '[/]report/employee_attendance',
	page_class: EmployeeAttendancePage,
	template: template,
	template_filename: 'translation/employee_attendance_report'
};
